// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2I16m","header":"ReportDetails_header__1oZSe","title":"ReportDetails_title__2oHYI","left":"ReportDetails_left__20c8M"};